import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getInvoiceDate, setInvoiceDate } from '../utils/dateSetter';
import { Button, Col, Form, Row } from 'react-bootstrap';

const InvoiceDateSettings: React.FC = () => {
  const { t } = useTranslation();    
  const [issueDate, setIssueDate] = useState<string>();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    const stored = getInvoiceDate();
    setIssueDate(stored ? stored : new Date().toLocaleDateString());
  }, []);

  const handleManualSet = () => {
    const date = new Date(inputValue).toLocaleDateString('en-EN');
    if (date !== 'Invalid Date') {
      setInvoiceDate(date)
      setIssueDate(date);
      alert(`${t('message.correctDate')}: ${date}`);
      setInputValue('');
    } else {
      alert(t('message.wrongDate'));
    }
  };

  return (
    <>
      <Row className="border p-3 rounded bg-white my-3">
        <h5>{t('issueDateSetUp')}</h5>
        <p>{t('issueDate')}: <strong>{issueDate}</strong></p>
        <Col>
           <Form.Control placeholder={`${t('forExample')}: 25/01/2025`} value={inputValue} type="date" className="my-2" onChange={(e) => setInputValue(e.target.value)} style={{backgroundColor: '#f5f7f9'}}/>              
        </Col>
        <Col>
        <Button className="btn btn-primary mt-1" onClick={handleManualSet}>
              {t('setDate')}
          </Button>
        </Col>                 
      </Row>
    </>
    
  );
};

export default InvoiceDateSettings;
